var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('qx-search-box',{staticClass:"searchBox",attrs:{"searchBoxData":_vm.searchBoxData,"title":"筛选","permpisionsQuery":""},on:{"sub":_vm.sub}}),_c('TableBox',{ref:"tableBox"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }